export const getScrollViewProps = () => ({
  showsHorizontalScrollIndicator: true,
});
